import React from 'react'
import { useTranslation } from "react-i18next";
import SingleDataTile from './SingleDataTile';
import ScoreDistributionTile from './ScoreDistributionTile';
import NetPromoterScoreTile from './NetPromoterScoreTile';
import LineChartTile from './LineChartTile';
import { useGetDashboard } from '../../hooks/dashboard/Dashboard';
import LoadingSpinner from '../global/LoadingSpinner';
import { useGetVendorId } from '../../hooks/global/User';

export default function Dashboard() {
    const { t } = useTranslation(); 

    const vendorId = useGetVendorId();
    const { data:state, isLoading, isError, refetch } = useGetDashboard();

    if (isLoading) return <LoadingSpinner />;
    if (isError) return 'An error has occurred: ' + isError.message;

    return (<>
        <div className="row firstRow">
            <div className="col-md-4">

                <SingleDataTile className={"tile tileBlue"}
                    value={state.invitationsStatistics?.currentCount}
                    difference={state.invitationsStatistics?.difference}
                    title={t("admin.common.invSent", { count: parseInt(state.invitationsStatistics?.currentCount) })} />
            </div>
            <div className="col-md-4">
                <a href={`/admin/vendors/${vendorId}/reviews`}>
                    <SingleDataTile className={"tile tileYellow"}
                        value={state.reviewsStatistics?.currentCount}
                        difference={state.reviewsStatistics?.difference}
                        title={t("admin.common.colOpi", { count: parseInt(state.reviewsStatistics?.currentCount) })} />
                </a>
            </div>
            <div className="col-md-4">
                <SingleDataTile className={"tile tileGreen"}
                    value={state.responseData?.currentPercentage}
                    difference={state.responseData?.difference}
                    postfix="%"
                    title={t("admin.common.custRes")} />
            </div>
        </div>
        <div className="row secondRow">
            <div className="col-md-4">
                {state.ratings && 
                <ScoreDistributionTile showTitleTile={true} showHeader={true} showDifference={false} reviewsStatistics={{}} ratings={state.ratings} />
                }
            </div>
            <div className="col-md-8">
                {state.reviewsDistribution &&  
                <LineChartTile chartData={{values: state.reviewsDistribution}} seriesPeriod={"DAY"} title={t("admin.common.colOpi", { count: 3 })} minYAxis={0} maxYAxis={100} />
                }
            
            </div>
        </div>
        <div className="row thirdRow">
            <div className="col-md-4">
                { state.npsscore && (
                <NetPromoterScoreTile npsStatistics={state.npsscore} />)
}
            </div>
            <div className="col-md-8">
                { state.npsDistribution &&
                <LineChartTile chartData={{values: state.npsDistribution}} 
                seriesPeriod={"DAY"}
                title={t("admin.common.moveNPS")}
                minYAxis={-100}
                maxYAxis={100} />
                }
            </div>
        </div>
    </>)
}
